export default "__VITE_ASSET__CPY3euLh__"